<template>
  <div>
    <custom-callout
      class="mb-3 custom-callout"
      :opened="equipment.isOpen"
      :border-color="equipment.statusColor"
      controlled
      @click:open="onToggle()"
    >
      <div class="row border-bottom py-3 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Equipo:
          </div>
          <div class="color-black font-16 font-weight-bold">
            {{
              equipment.equipment != null && equipment.equipment != ''
                ? equipment.equipment.charAt(0).toUpperCase() +
                  equipment.equipment.slice(1)
                : '-'
            }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Estudiante:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ equipment.studentName | empty }}
          </div>
        </div>
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Código Inventario:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ equipment.equipmentInventoryCode | empty }}
          </div>
        </div>
        <div class="col">
          <drop-down :items="actionItems" class="float-md-right mr-5" />
        </div>
      </div>
      <div class="row py-3 m-0">
        <div class="col-md-3 col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Estatus:
          </div>
          <div class="mt-2 d-flex align-items-center">
            <div
              :style="'background-color:' + equipment.statusColor"
              class="equipment-balloon-container w-unset"
            ></div>
            <span class="font-weight-bold">{{ equipment.status | empty }}</span>
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Método:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ getPurchaseMethod(equipment.method) | empty }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Número de PO:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ equipment.poNumber | empty }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            PO Estatus:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ equipment.poStatus | empty }}
          </div>
        </div>
        <div class="col-sm col-12 col-spacing student-spacing">
          <div class="color-secondary-6 font-14 font-weight-normal mr-2">
            Número de Requisición:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ equipment.reqNumber | empty }}
          </div>
        </div>
      </div>

      <template #edition>
        <div v-if="showTabs" class="bg-light-gray p-2">
          <div class="bg-white py-3 px-md-3 rounded">
            <equipment-tabs
              :equipment="equipment"
              :tab-index="tabIndex"
              @onTabChanged="onTabChanged"
            ></equipment-tabs>
          </div>
        </div>
        <add-binnacle
          v-if="showAddBinnacle"
          v-model="model.binnacle"
          @cancel="handlerClose"
          @save="handlerAddBinnacle"
        />
        <document-date
          v-if="showDocumentDate"
          :recommendation="equipment"
          v-model="model.documentDate"
          @cancel="handlerClose"
          @save="handlerDocumentDate"
          :is-c-s-e-e="isCSEE"
        />
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import EquipmentTabs from './EquipmentTabs.vue';
import DocumentDate from './components/DocumentDate.vue';
import AddBinnacle from './components/AddBinnacle.vue';
import mixAlert from '@/mixins/alert.mixin';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import peiATServiceStatus from '@/utils/constants/peiATServiceStatus';
import purchaseMethod from '@/utils/constants/purchaseMethods';
import { serialize as objectToFormData } from 'object-to-formdata';
import peiAtReferralTypes from '@/utils/constants/peiAtReferralType';

export default {
  name: 'EquipmentRow',
  components: {
    CustomCallout,
    DropDown,
    EquipmentTabs,
    AddBinnacle,
    DocumentDate,
  },
  mixins: [mixAlert],
  props: {
    equipment: {
      type: Object,
      required: true,
    },
    isInventoryFlowEnabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      tabIndex: 0,
      showAddBinnacle: false,
      showDocumentDate: false,
      model: {
        binnacle: {},
        documentDate: {},
      },
    };
  },
  computed: {
    actionItems() {
      return [
        {
          name: 'Añadir Bitácora',
          icon: 'far fa-comment text-green',
          border: 'bottom',
          click: () => this.handlerOpenAddBinnacle(),
        },
        {
          name: 'Recibido CSEE',
          icon: 'fas fa-calendar-edit text-success',
          click: () => this.handlerOpenDocumentDate(),
          visible: () => this.isCSEE,
        },
        {
          name: 'Entrega Escuela',
          icon: 'fas fa-calendar-edit text-success',
          click: () => this.handlerOpenDocumentDate(),
          visible: () =>
            [peiATServiceStatus.PendienteDeEntregaEscuela].includes(
              this.equipment.statusId
            ),
        },
        {
          name: this.isAcquisition
            ? 'Análisis de Adquisición'
            : 'Análisis de Requisición',
          icon: 'far fa-file-chart-pie text-success',
          visible: () =>
            this.userHasPermissions(
              'technologyassistance.referralmanagment.requisitionanalysis'
            ) &&
            [
              peiATServiceStatus.PendienteAnalisisRequisicion,
              peiATServiceStatus.PendienteDeRequisicion,
            ].includes(this.equipment.statusId),
          click: () =>
            this.$router.push({
              name: 'RequisitionAnalysis',
              params: { id: this.equipment.peiAtServiceId },
            }),
        },
      ];
    },
    isCSEE() {
      return [peiATServiceStatus.PendienteDeEntregaCSEE].includes(
        this.equipment.statusId
      );
    },
    showTabs() {
      return !this.showAddBinnacle && !this.showDocumentDate;
    },
    isAcquisition() {
      return this.isInventoryFlowEnabled && Boolean(this.equipment.catalogId);
    },
  },
  methods: {
    getPurchaseMethod(id) {
      if (!id) return '-';
      return id === purchaseMethod.SIFDE ? 'SIFDE' : 'Inventario';
    },
    onTabChanged(index) {
      this.tabIndex = index;
    },
    async onToggle() {
      this.showAddBinnacle = false;
      this.showDocumentDate = false;
      if (this.equipment.isOpen) {
        this.$emit('close', this.equipment);
        return;
      }
      this.$emit('open', this.equipment);
    },
    handlerOpenAddBinnacle() {
      this.$emit('open', this.equipment);
      this.showAddBinnacle = true;
      this.showDocumentDate = false;
    },
    handlerOpenDocumentDate() {
      this.$emit('open', this.equipment);
      this.showAddBinnacle = false;
      this.showDocumentDate = true;
    },
    handlerClose() {
      this.showAddBinnacle = false;
      this.showDocumentDate = false;
      this.model.documentDate = {};
      this.$emit('close', this.equipment);
    },
    async handlerAddBinnacle() {
      const payload = objectToFormData({
        ...this.model.binnacle,
        peiAtServiceId: this.equipment.id,
      });

      const { data } = await referralAndEquipmentsservice
        .saveEquipmentBinnacle(payload)
        .catch((error) => {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        });
      if (data) {
        this.model.binnacle = {
          attachment: null,
          attachmentId: null,
          comment: null,
          documentName: null,
        };
        this.ShowToast(
          'Éxito',
          'Se ha guardado la bitácora correctamente',
          'success'
        );
        this.handlerClose();
      }
    },
    async handlerDocumentDate() {
      const validType = [
        peiAtReferralTypes.EquipmentRelatedServiceRequest,
        peiAtReferralTypes.TechnicalAssistanceServiceRequest,
      ].includes(this.equipment.referralTypeId);

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        this.isCSEE
          ? `¿Está seguro que desea cambiar el estatus del equipo de Pendiente de Entrega CSEE a Pendiente de Entrega Escuela?`
          : validType
          ? '¿Está seguro que desea cambiar el estatus del equipo de Pendiente de Entrega Escuela a Servido?'
          : '¿Está seguro que desea cambiar el estatus del equipo de Pendiente de Entrega Escuela a Pendiente de Discusión Escuela?',
        'Sí',
        'No'
      );
      if (isConfirmed) {
        const payload = {
          date: this.model.documentDate.date,
          isCSEE: this.isCSEE,
          id: this.equipment.id,
          peiAtServiceId: this.equipment.peiAtServiceId,
        };

        try {
          const { data } = await referralAndEquipmentsservice.saveDocumentDate(
            payload
          );

          this.model.documentDate = {};
          this.ShowToast(
            'Éxito',
            'Se ha cambiado el estatus del equipo correctamente',
            'success'
          );
          this.handlerClose();
          this.$emit('refresh');
        } catch (error) {
          this.ShowToast('Error', error?.response?.data.message, 'error');
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.width-container {
  width: 100% !important;
}
.equipment-balloon-container {
  margin-left: 5px;
  margin-right: 5px;
  padding: 5px;
  text-align: center;
  color: #11291b;
  border-radius: 25px;
  font-size: 14px;
  font-weight: 900;
  width: 100%;
  width: unset;
}
::v-deep div.custom-callout div.bg-secondary-3 {
  border-bottom: solid #ffffff 2px !important;
}
</style>
